export default __webpack_public_path__ + "static/media/BearPage2.c01593f3.txt";